<template>
    <m-input :active="focus" @click="setFocus()" :line="showLine" :error="error">
        <div class="table items-center bg-white border rounded my-1 w-full p-2">
            <div class="table-cell w-1 align-middle">
                <div class="sprite-icons-search bg-white"></div>
            </div>
            <div class="table-cell align-middle">
                <input class="w-full outline-none truncate" v-model="inputText" @focus="focus = true"
                       @blur="focus = false" ref="input" @input.self="inputChanged"
                       @keydown.enter="$emit('enter', inputText)" autocomplete="new-password"/>
            </div>
            <div class="table-cell w-1 align-middle">
                <div class="btn btn-primary" @click="$emit('enter', inputText)">Search</div>
            </div>
        </div>
        <div class="shadow fixed overflow-y-auto z-50 bg-white" v-show="focus && inputText" @mousedown.prevent=""
             style="min-width: 220px; max-height: 180px">
            <slot name="empty" v-if="options.length == 0"></slot>
            <ul class="select text-left" v-else>
                <li class="p-2 block cursor-pointer hover_bg-gray-300" v-for="option in options"
                    @click.stop="clickOption(option)">
                    <slot name="item" :option="option">{{ option }}</slot>
                </li>
            </ul>
        </div>
    </m-input>
</template>
<script>
export default {
    props: {
        options: [Array, Object],
        showLine: {
            type: Boolean,
            default: true
        },
        error: {
            type: Boolean,
            default: false
        },
        value: String
    },
    data() {
        return {
            focus: false,
            inputText: ''
        }
    },
    methods: {
        setFocus() {
            this.$refs.input.focus();
            this.focus = true
        },
        clickOption(item) {
            this.focus = false
            this.$emit('click', item)
        },
        inputChanged() {
            this.$emit('input', this.inputText)
        }
    }
}
</script>
